import styles from "@/styles/login-layout.module.scss"
import React from "react"
import Image from 'next/image'
import Link from 'next/link'

interface LayoutProps {
  children: React.ReactNode;
  wideScreen?: boolean;  // 是否使用宽屏
  useChristmasTheme?: boolean; // 是否使用圣诞主题
  notStickyNavbar?: boolean; // 是否取消Navbar吸顶效果
}

export default function LoginLayout(props: LayoutProps) {
  return (
    <div className={styles['login-layout']}>
      <div className={styles['header']}>
        <Link
          href='/'
          legacyBehavior
        >
          <a rel="noopener noreferrer">
            <Image
              className={styles['site-logo']}
              alt="logo"
              priority={true}
              width={246}
              height={70}
              src="//static.crazysales.com.au/images/2022v/img/logo.svg" />
          </a>
        </Link>
      </div>

      <main style={{ background: '#F5F5F5', minHeight: 'calc(100vh - 200px)' }}>{props.children}</main>

      <div className={styles['footer']}>
        <Link
          href='/article/TermsAndConditions'
          legacyBehavior
        >
          <a className={styles['link']} rel="noopener noreferrer">
            Terms & Conditions
          </a>
        </Link>

        <div className={styles['separate']}></div>

        <Link
          href='/article/PrivacyStatement'
          legacyBehavior
        >
          <a className={styles['link']} rel="noopener noreferrer">
            Privacy Statement
          </a>
        </Link>

        <div className={styles['separate']}></div>

        <Link
          href='/'
          legacyBehavior
        >
          <a className={styles['link']} rel="noopener noreferrer">
            <Image
              className={styles['site-logo']}
              alt="logo"
              priority={true}
              width={112}
              height={27}
              src="https://www.crazysales.com.au/images/easy-layout-Norton.png" />
          </a>
        </Link>

        <div className={styles['separate']}></div>

        <Link
          href='/'
          legacyBehavior
        >
          <Image
            className={styles['site-logo']}
            alt="logo"
            priority={true}
            width={88}
            height={47}
            src="https://www.crazysales.com.au/images/easy-layout-comodo.png" />
        </Link>
      </div>
    </div>
  )
}